// Workbook SDLC version options, shared by the hub filter and the viewer filter.
export const VALID_VERSIONS = ["alpha", "beta", "live"];
export const DEFAULT_VERSION = "live";

// Single source of truth for the default-laden entry-point links (sidebar, home
// card). Keeping it here prevents the key/value drift that previously shipped a
// `?workbook_version=live` link the page never read.
export const ANALYTICS_HUB_DEFAULT_SEARCH = `?workbookVersion=${DEFAULT_VERSION}`;

// Page-scoped params owned by the analytics hub. Used to strip them from the URL
// when navigating to other routes so they don't leak onto unrelated pages.
// Keep in sync with analyticsHubParsers in ./search.
export const ANALYTICS_HUB_PARAM_KEYS = [
  "workbookVersion",
  "workbookCatalogId",
  "workbookUrlId",
  "savedViewId",
  "exploreKey",
];

// First entry in the view picker: the workbook as published. No record behind
// it, hence the empty string — Combobox reads null as "nothing selected".
export const STANDARD_VIEW_VALUE = "";
export const STANDARD_VIEW_OPTION = {
  value: STANDARD_VIEW_VALUE,
  label: "Standard View",
};

// The two modes `SavedViewPanel` can open in: `create` captures the current
// exploration under a new name (also used by Save As); `edit` renames or
// reflags an existing view.
/** @type {{create: "create", edit: "edit"}} */
export const SAVED_VIEW_PANEL_MODE = {
  create: "create",
  edit: "edit",
};

/**
 * @typedef {(typeof SAVED_VIEW_PANEL_MODE)[keyof typeof SAVED_VIEW_PANEL_MODE]} SavedViewPanelMode
 */

// Visibility filter for the saved-view picker. `all` groups the options under
// Public and Private headings; the others flatten to that slice.
export const SAVED_VIEW_FILTERS = {
  all: "all",
  public: "public",
  private: "private",
};

export const SAVED_VIEW_FILTER_OPTIONS = [
  { value: SAVED_VIEW_FILTERS.all, label: "All" },
  { value: SAVED_VIEW_FILTERS.public, label: "Public" },
  { value: SAVED_VIEW_FILTERS.private, label: "Private" },
];
